// extracted by mini-css-extract-plugin
module.exports = {"open_in_codespace__header":"open-in-codespaces-module--open_in_codespace__header--1pnpf","open_in_codespace__text":"open-in-codespaces-module--open_in_codespace__text--2kyec"};